import React, { useCallback } from 'react';
import EDCheckbox from '../../BaseComponents/Checkboxes/EDCheckbox';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import { IConsent } from './CookieSettingsUtils';

interface IProps {
  consent: IConsent;
  setConsent: (consent: IConsent) => void;
}

export const CookieSettings: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { setConsent } = props;
  const checkStatistik = useCallback(
    (checked: boolean) => {
      setConsent({ ...props.consent, statistics: checked });
    },
    [props.consent, setConsent]
  );

  const checkErrorReports = useCallback(
    (checked: boolean) => {
      setConsent({ ...props.consent, errorReports: checked });
    },
    [props.consent, setConsent]
  );
  return (
    <>
      <EDTypography marginBottom={1}>
        Vi bryr oss om din integritet!
      </EDTypography>
      <EDTypography>
        Aveny använder vissa cookies för att programmet ska fungera, dessa kan
        du inte välja bort. Andra används för att förbättra programmet och
        underlätta felrapportering om du ger ditt tillstånd.
      </EDTypography>

      <EDCheckbox label="Nödvändiga" checked disabled />
      <EDTypography>
        Nödvändiga cookies används för att hantera inloggning i systemet och för
        att komma ihåg uppgifter som du specifikt begär, till exempel
        användarnamn vid inloggning.
      </EDTypography>

      <EDCheckbox
        label="Felrapportering"
        checked={props.consent.errorReports}
        onCheck={checkErrorReports}
      />
      <EDTypography>
        Tillåtelse att data samlas in vid interna programfel. Felet rapporteras
        automatiskt och möjliggör snabbare felsökning och rättning i systemet.
      </EDTypography>

      <EDCheckbox
        label="Statistik"
        checked={props.consent.statistics}
        onCheck={checkStatistik}
      />
      <EDTypography>
        Tillåtelse att använda cookies för att förbättra programstatistik över
        vilka funktioner som används. Statistiken används till att förbättra
        Aveny och göra systemet ännu mer användaranpassat.
      </EDTypography>
    </>
  );
};
